import { useEffect, useState } from "react";
// for work_images
import work1 from "../assets/images/work_images/1.jpg";
import work2 from "../assets/images/work_images/2.jpg";
import work3 from "../assets/images/work_images/3.jpg";
import work4 from "../assets/images/work_images/4.jpg";
import work5 from "../assets/images/work_images/5.jpg";
import work6 from "../assets/images/work_images/6.jpg";
import work7 from "../assets/images/work_images/7.jpg";
import work8 from "../assets/images/work_images/8.jpg";
import work9 from "../assets/images/work_images/9.jpg";
// works small images
import workSmall1 from "../assets/images/work_images/small/1.jpg";
import workSmall2 from "../assets/images/work_images/small/2.jpg";
import workSmall3 from "../assets/images/work_images/small/3.jpg";
import workSmall4 from "../assets/images/work_images/small/4.jpg";
import workSmall5 from "../assets/images/work_images/small/5.jpg";
import workSmall6 from "../assets/images/work_images/small/6.jpg";
import workSmall7 from "../assets/images/work_images/small/7.jpg";
import workSmall8 from "../assets/images/work_images/small/8.jpg";
import workSmall9 from "../assets/images/work_images/small/9.jpg";
// blog post images
import blog6 from "../assets/images/blog_images/6.jpg";
import blog4 from "../assets/images/blog_images/4.jpg";
import blog2 from "../assets/images/blog_images/2.jpg";
import blog1 from "../assets/images/blog_images/1.jpg";
import blog3 from "../assets/images/blog_images/3.jpg";
import blog5 from "../assets/images/blog_images/5.jpg";
// blog image small
import blogSmall6 from "../assets/images/blog_images/small/6.jpg";
import blogSmall4 from "../assets/images/blog_images/small/4.jpg";
import blogSmall2 from "../assets/images/blog_images/small/2.jpg";
import blogSmall1 from "../assets/images/blog_images/small/1.jpg";
import blogSmall3 from "../assets/images/blog_images/small/3.jpg";
import blogSmall5 from "../assets/images/blog_images/small/5.jpg";

import img1 from "../assets/images/slider/brand-1.png";
import img2 from "../assets/images/slider/brand-2.png";
import img3 from "../assets/images/slider/brand-3.png";
import img4 from "../assets/images/slider/brand-4.png";
import img5 from "../assets/images/slider/brand-5.png";
//  icon use as img here
import icon from "../assets/images/icons/icon-1.svg";
import icon1 from "../assets/images/icons/icon-2.svg";
import icon2 from "../assets/images/icons/icon-3.svg";
import icon3 from "../assets/images/icons/icon-4.svg";
import icon4 from "../assets/images/icons/icon-5.svg";
import icon5 from "../assets/images/icons/icon-6.svg";
// contact image
import iconPhone from "../assets/images/contact/phone-call 1.png";
import iconEmail from "../assets/images/contact/email 1.png";
import iconMap from "../assets/images/contact/map 1.png";

import sylius from "../assets/images/sylius.png"
import wordpress from "../assets/images/wordpress.svg"
import react from "../assets/images/react.svg"
import symfony from "../assets/images/symfony.svg"
import laravel from "../assets/images/laravel.svg"
import awsWhite from "../assets/images/aws-white.svg"
import awsBlack from "../assets/images/aws-black.svg"
import linux from "../assets/images/linux.svg"



import { CgNotes } from "react-icons/cg";
import { FaBlogger, FaRegUser, FaCode } from "react-icons/fa";
import { AiOutlineHome } from "react-icons/ai";
import { FiCodesandbox } from "react-icons/fi";
import { RiContactsBookLine } from "react-icons/ri";
import { Link, useLocation } from "react-router-dom";
import i18n from "../i18n";
import {useTranslation} from "react-i18next";
import ReactGA from "react-ga4";

const AllData = () => {
  const [check, setCheck] = useState(false);
  const [local, setLocal] = useState(localStorage.getItem("theme"));
  const [singleData, setSingleData] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [setSelectedLanguage] = useState(i18n.language);
  const { t } = useTranslation();



  // dark and light theme controls
  useEffect(() => {
    ReactGA.initialize("G-8D228CXVGW");
    const language = localStorage?.getItem("language")
    if(language) {
      i18n.changeLanguage(language);
    }

    const themeValue = localStorage?.getItem("theme");
    if (!themeValue) {
      setCheck(true);
      localStorage.setItem("theme", "dark");
    } else {
      themeValue === "dark" && setCheck(true);
      themeValue === "light" && setCheck(false);
    }

    localStorage?.getItem("theme") === "dark"
      ? document.documentElement.classList.add("dark")
      : document.documentElement.classList.remove("dark");
  }, []);

  // Create and light theme function
  const handleTheme = (value) => {
    if (value === "light") {
      setCheck(false);
      localStorage.setItem("theme", "light");
      setLocal("light");
    } else {
      setCheck(true);
      localStorage.setItem("theme", "dark");
      setLocal("dark");
    }
    localStorage?.getItem("theme") === "dark"
      ? document.documentElement.classList.add("dark")
      : document.documentElement.classList.remove("dark");
  };

  const handleLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage?.setItem("language", lang);
  };

  // fillter portfilo data
  const handleData = (text) => {
    if (text === "All") {
      setData(workItems);
    } else {
      const findData = workItems.filter((item) => item.tag === text);
      setData(findData);
    }
  };

  // find items for portfilo  modal open
  const handleModelData = (id) => {
    const find = workItems.find((item) => item?.id === id);
    setSingleData(find);
    setIsOpen(true);
  };
  // find items for Blogs  modal open
  const handleBlogsData = (id) => {
    const find = blogsData.find((item) => item?.id === id);
    setSingleData(find);
    setIsOpen(true);
  };

  // Active navlinks function
  function NavLink({
    to,
    className,
    activeClassName,
    inactiveClassName,
    ...rest
  }) {
    let location = useLocation();
    let isActive = location.pathname === to;
    let allClassNames =
      className + (isActive ? `${activeClassName}` : `${inactiveClassName}`);
    return <Link className={allClassNames} to={to} {...rest} />;
  }

  // Elements for protfilo section
  const workItems = [
    {
      id: "1",
      tag: "WpTheme",
      title: "Websupport",
      slug: "websupport",
      create: "Andrej Szabo",
      path: "websupport",
      technology: "Wordpress",
      gallery: [
        "Hosting",
        "VPS",
        "Storage",
        "DedicatedServers",
        "VDC",
        "AboutUs",
        "EasySEO",
        "Sitebuilder",
        "Contact",
        "Position",
        "Hiring",
      ],
      year: "2023",
      link: "https://www.websupport.sk/",
      linkText: "websupport.sk",
      description_sk: "Websupport je slovenská webhostingová spoločnosť, ktorá na trhu pôsobí od roku 2002. Od roku 2011 pôsobí aj v Česku, Maďarsku a Rakúsku. V roku 2019 sa stala súčasťou medzinárodnej skupiny Loopia Group. Projekt bol vypracovaný v spolupráci s firmou <a class=\"font-semibold transition-all duration-300 ease-in-out hover:text-[#ef4060]\" target=\"_blank\" href=\"https://webikon.sk/\">Webikon s.r.o.</a>",
      description_en: "Websupport is a Slovak web hosting company that has been operating in the market since 2002. Since 2011, it has also been active in the Czech Republic, Hungary, and Austria. In 2019, it became part of the international Loopia Group. The project was developed in collaboration with <a class=\"font-semibold transition-all duration-300 ease-in-out hover:text-[#ef4060]\" target=\"_blank\" href=\"https://webikon.sk/\">Webikon s.r.o.</a>"
    },
    {
      id: "2",
      tag: "eCommerce",
      title: "Deermates",
      slug: "deermates",
      create: "Andrej Szabo",
      path: "deermates",
      technology: "Sylius, Symfony",
      gallery: [
        "index",
        "checkout",
        "cart",
        "product",
        "product2",
        "cat2",
        "cat",
        "settings",
        "faq",
        "dashboard",
        "contact",
        "about",
      ],
      year: "2023",
      link: "https://www.websupport.sk/",
      linkText: "websupport.sk",
      description_sk: "Websupport je slovenská webhostingová spoločnosť, ktorá na trhu pôsobí od roku 2002. Od roku 2011 pôsobí aj v Česku, Maďarsku a Rakúsku. V roku 2019 sa stala súčasťou medzinárodnej skupiny Loopia Group. Projekt bol vypracovaný v spolupráci s firmou <a class=\"font-semibold transition-all duration-300 ease-in-out hover:text-[#ef4060]\" target=\"_blank\" href=\"https://webikon.sk/\">Webikon s.r.o.</a>",
      description_en: "Websupport is a Slovak web hosting company that has been operating in the market since 2002. Since 2011, it has also been active in the Czech Republic, Hungary, and Austria. In 2019, it became part of the international Loopia Group. The project was developed in collaboration with <a class=\"font-semibold transition-all duration-300 ease-in-out hover:text-[#ef4060]\" target=\"_blank\" href=\"https://webikon.sk/\">Webikon s.r.o.</a>"
    },
    {
      id: "3",
      tag: "Other",
      title: "Žihadielko Lidl 2018",
      slug: "zihadielko",
      create: "Andrej Szabo",
      path: "zihadielko",
      technology: "Symfony",
      gallery: [
        "zihadielko-homepage",
        "zihadielko-neprihlaseny",
        "zihadielko-prihlaseny",
        "zihadielko-vyzva",
        "zihadielko-mobile",
      ],
      year: "2018",
      link: "https://zihadielko.lidl.sk/",
      linkText: "zihadielko.lidl.sk",
      description_sk: "Miestna súťaž organizovaná spoločnosťou Lidl v Slovenskej republike. Mestá, ktoré vyhrajú, tak Lidl im postaví nové ihrisko.",
      description_en: "Local competition organized by Lidl in the Slovak Republic. The cities that win will have a new playground built by Lidl for them."
    },
    {
      id: "4",
      tag: "WpTheme",
      title: "ŠKODA bike open tour",
      slug: "skoda",
      create: "Andrej Szabo",
      path: "skoda",
      technology: "Laravel",
      gallery: [
        "bike-tour-home-odpocitavanie",
        "bike-tour-home-sprievodne-sutaze_on-site_v2",
        "bike-tour-home-sprievodne-sutaze-Visin-kids0",
        "bike-tour-home-sprievodne-sutaze",
        "bike-tour-pravidla_v3-NF",
        "bike-tour-pravidla",
        "bike-tour-vysledky",
        "bike-tour-galerie",
      ],
      year: "2018",
      link: "https://www.welovecycling.com/sk/sbot/",
      linkText: "www.welovecycling.com",
      description_sk: "Najprestížnejšie preteky horských bicyklov na Slovensku.",
      description_en: "The most prestigious mountain bike races in Slovakia."
    },
    {
      id: "5",
      tag: "Other",
      title: "Canon premium program",
      slug: "canon",
      create: "Andrej Szabo",
      path: "canon",
      technology: "Laravel",
      gallery: [
        "akcie",
        "body",
        "darceky",
        "home",
        "kosik",
        "objednavky",
        "produkt-detail",
      ],
      year: "2019",
      link: "https://www.premiumprogram.sk/",
      linkText: "www.premiumprogram.sk",
      description_sk: "Vernostný klub umožňujúci výmenu bodov za darčeky. Projekt bol vypracovaný v spolupráci s firmou <a class=\"font-semibold transition-all duration-300 ease-in-out hover:text-[#ef4060]\" target=\"_blank\" href=\"https://mlv.sk/\">Mill Valley s.r.o.</a>",
      description_en: "Loyalty club enabling point redemption for gifts. The project was developed in collaboration with <a class=\"font-semibold transition-all duration-300 ease-in-out hover:text-[#ef4060]\" target=\"_blank\" href=\"https://mlv.sk/\">Mill Valley s.r.o.</a>"
    },
    {
      id: "6",
      tag: "eCommerce",
      title: "EXIMBANKA SR",
      slug: "eximbanka",
      create: "Andrej Szabo",
      path: "eximbanka",
      technology: "Laravel",
      gallery: [
        "index",
        "profile",
        "products",
        "contact",
      ],
      year: "2016",
      link: "https://eximbanka.sk/",
      linkText: "eximbanka.sk",
      description_sk: "Exportno-importná banka Slovenskej republiky. Projekt bol vypracovaný v spolupráci s firmou <a class=\"font-semibold transition-all duration-300 ease-in-out hover:text-[#ef4060]\" target=\"_blank\" href=\"https://www.ui42.sk/\">ui 42 spol. s r. o.</a>",
      description_en: "Export-Import bank of the Slovak Republic. The project was developed in collaboration with <a class=\"font-semibold transition-all duration-300 ease-in-out hover:text-[#ef4060]\" target=\"_blank\" href=\"https://www.ui42.sk/\">ui 42 spol. s r. o..</a>"
    },
    {
      id: "7",
      tag: "WpTheme",
      title: "SunSense",
      slug: "sunsense",
      create: "Andrej Szabo",
      path: "sunsense",
      technology: "Wordpress",
      gallery: [
        "sunsense1",
        "sunsense1a",
        "sunsense2",
        "sunsense2a",
        "sunsense3",
        "sunsense3a",
        "sunsense4",
        "sunsense4a",
        "sunsense5",
        "sunsense6",
        "sunsense6a",
        "sunsense6b",
        "sunsense6c",
        "sunsense7",
        "sunsense7a",
        "sunsense8",
      ],
      year: "2019",
      link: "https://www.sunsense.co.uk/",
      linkText: "www.sunsense.co.uk",
      description_sk: "Bodový systém pre zákazníkov SunSense, vytvorený formou WordPress pluginu. Taktiež ďalšie úpravy existujúcej témy. Projekt bol vypracovaný v spolupráci s firmou <a class=\"font-semibold transition-all duration-300 ease-in-out hover:text-[#ef4060]\" target=\"_blank\" href=\"https://brightbox.cz/\">BrightBox s.r.o.</a>",
      description_en: "Point system for SunSense customers, created as a WordPress plugin. Additionally, modifications to an existing theme were made. The project was developed under the company <a class=\"font-semibold transition-all duration-300 ease-in-out hover:text-[#ef4060]\" target=\"_blank\" href=\"https://brightbox.cz/\">BrightBox s.r.o.</a>"
    },
    {
      id: "8",
      tag: "eCommerce",
      title: "Stavebné konania",
      slug: "stavebne-konania",
      create: "Michal Varga, Andrej Szabo",
      path: "stavebne-konania",
      technology: "Laravel",
      gallery: [
        "index",
        "index-menu",
        "admin-manage",
        "admin-mapa",
        "newsletter",
        "about",
      ],
      year: "2016",
      link: "http://konania.sk/",
      linkText: "konania.sk",
      description_sk: "Cieľom portálu je informovať širokú verejnosť o aktuálnych stavebných konaniach. Informovanosť umožnuje verejnosti zapojiť sa do rozhodovacích procesov. Informácie pre vás zbierame z verejných zdrojov, tak aby boli aktuálne, a pre vás relevantné.",
      description_en: "The purpose of the portal is to inform the general public about current construction proceedings. This information allows the public to participate in decision-making processes. We collect information for you from public sources to ensure it is up-to-date and relevant for you."
    },
    {
      id: "9",
      tag: "WpTheme",
      title: "Grandhotel Brno ****",
      slug: "grandhotel-brno",
      create: "Andrej Szabo",
      path: "grandhotel-brno",
      technology: "Wordpress",
      gallery: [
        "Homepage",
        "Ubytovani",
        "Gastronomia",
        "Historia",
        "Eventy",
        "Kontakt",
      ],
      year: "2018",
      link: "https://grandhotelbrno.cz/",
      linkText: "grandhotelbrno.cz",
      description_sk: "Hotel so 100 ročnou tradíciou v centre Brna, Česká republika.",
      description_en: "A hotel with a 100-year tradition in the center of Brno, Czech Republic."
    },
    {
      id: "10",
      tag: "WpTheme",
      title: "Avanti Api",
      slug: "chul-urina",
      create: "Andrej Szabo",
      path: "avanti",
      technology: "Wordpress",
      gallery: [
        "avanti1",
        "avanti2",
        "avantiapi-home2",
        "avantiapi-home",
        "avantiapi-sluzby",
        "avantiapi-novinky",
        "avantiapi-dopravne-prostriedky",
        "avantiapi-fotogaleria",
        "avantiapi-kontakt",
      ],
      year: "2015",
      link: "http://www.avantiapi.sk",
      linkText: "www.avantiapi.sk",
      description_sk: "Spoločnosť Avanti Api (v preklade \"včely vpred\") vznikla z myšlienky priniesť ľuďom komfortné cestovanie za nízke ceny. Túto myšlienku nám pomáhajú realizovať luxusné viacmiestne automobily Mercedes-Benz Vito Tourer bielej farby. Naše usilovné biele “včielky” odchádzajú do európskych destinácií z Brna, kde sídli aj celé zázemie našej firmy. V súčasnej dobe môžete vidieť na cestách niekoľko týchto áut s včelou v našom logu. V budúcnosti sa naša prepravné flotila viacmiestnych vozidiel bude rozrastať v pravidelných intervaloch aj o iné typy vozidiel.",
      description_en: "The company Avanti Api (translated as \"bees forward\") originated from the idea of bringing people comfortable travel at low prices. This idea is realized with the help of luxurious multi-passenger Mercedes-Benz Vito Tourer vehicles in white color. Our diligent white \"bees\" depart from Brno to European destinations, where our company is based. Currently, you can see several of these vehicles with a bee in our logo on the roads. In the future, our transport fleet of multi-passenger vehicles will expand at regular intervals to include other types of vehicles.",
    },
  ];
  const [data, setData] = useState(workItems);
  const [dataCatsAll, setDataCatsAll] = useState([...new Set(workItems.map(item => item.tag))]);

  // Elements for Blogs section
  const blogsData = [
    {
      id: "1",
      img: blog1,
      imgSmall: blogSmall1,
      date: "177 April",
      category: "Inspiration",
      title: "How to Own Your Audience by Creating an Email List.",
      bg: "#FCF4FF",
      description:
        "Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum conseqr quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consetur quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. ",
    },
    {
      id: "4",
      img: blog4,
      imgSmall: blogSmall4,
      date: "000 April",
      category: "Inspiration",
      title: "Everything You Need to Know About Web Accessibility.",
      bg: "#EEFBFF",
      description:
        "Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum conseqr quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consetur quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. ",
    },
    {
      id: "2",
      img: blog2,
      imgSmall: blogSmall2,
      date: "21 April",
      category: "Web Design",
      title: "The window know to say beside you",
      bg: "#FFF0F0",
      description:
        "Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum conseqr quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consetur quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. ",
    },
    {
      id: "5",
      img: blog5,
      imgSmall: blogSmall5,
      date: "27 April",
      category: "Inspiration",
      title: "Top 10 Toolkits for Deep Learning in 2021.",
      bg: "#FCF4FF",
      description:
        "Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum conseqr quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consetur quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. ",
    },
    {
      id: "3",
      img: blog3,
      imgSmall: blogSmall3,
      date: "27 April",
      category: "Inspiration",
      title: "How to Own Your Audience by Creating an Email List.",
      bg: "#FCF4FF",
      description:
        "Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum conseqr quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consetur quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. ",
    },
    {
      id: "6",
      img: blog6,
      imgSmall: blogSmall6,
      date: "27 April",
      category: "Inspiration",
      title: "Everything You Need to Know About Web Accessibility.",
      bg: "#EEFBFF",
      description:
        "Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum conseqr quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consetur quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. ",
    },
  ];

  // Menu items for Homepage One
  const menuItem = [
    {
      id: "01",
      name: "Home",
      link: "/home/homePage",
      icon: <AiOutlineHome />,
    },
    {
      id: "02",
      name: t("AboutMe"),
      link: "/home/about",
      icon: <FaRegUser />,
    },
    {
      id: "06",
      name: t("Skills"),
      link: "/home/skills",
      icon: <CgNotes />,
    },
    {
      id: "03",
      name: "Works",
      link: "/home/works",
      icon: <FiCodesandbox />,
    },
    {
      id: "04",
      name: "Blogs",
      link: "/home/blogs",
      icon: <FaBlogger />,
    },
    {
      id: "05",
      name: "Contact",
      link: "/home/contact",
      icon: <RiContactsBookLine />,
    },
  ];

  // Menu items for Homepage Two
  const menuItemTwo = [
    {
      id: "01",
      name: t("About"),
      link: "/",
      icon: <FaRegUser />,
    },
    {
      id: "02",
      name: t("Skills"),
      link: "/skills",
      icon: <FaCode />,
    },
    {
      id: "03",
      name: t("Portfolio"),
      link: "/portfolio",
      icon: <FiCodesandbox />,
    },
    /*{
      id: "04",
      name: "Blogs",
      link: "/blogs",
      icon: <FaBlogger />,
    },*/
    {
      id: "05",
      name: t("Contact"),
      link: "/contact",
      icon: <RiContactsBookLine />,
    },
  ];

  // Slider image for Clients
  const sliderImg = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img1,
    img2,
    img3,
    img4,
    img5,
  ];

  // serviceArray items for about page
  const serviceArray = [
    {
      id: "1",
      icon_light: sylius,
      icon_dark: sylius,
      title: "Sylius",
      des_sk: "Open Source Headless eCommerce platforma pre stredne veľké a veľké projekty",
      des_en: "Open Source Headless eCommerce Platform for mid-market and enterprise projects",
      color: "#D566FF",
      bg: "#FCF4FF",
    },
    {
      id: "2",
      icon_light: symfony,
      icon_dark: symfony,
      title: "Symfony",
      des_sk: "PHP framework na tvorbu webových aplikácií, API, mikroslužieb a webových služieb",
      des_en: "PHP framework to build web applications, APIs, microservices and web services",
      color: "#8774FF",
      bg: "#FCF4FF",
    },
    {
      id: "3",
      icon_light: laravel,
      icon_dark: laravel,
      title: "Laravel",
      des_sk: "PHP framework na tvorbu webových aplikácií, API, mikroslužieb a webových služieb",
      des_en: "PHP framework to build web applications, APIs, microservices and web services",
      color: "#FF6080",
      bg: "#FFF4F4",
    },
    {
      id: "2",
      icon_light: wordpress,
      icon_dark: wordpress,
      title: "Wordpress",
      des_sk: "Open source publikačný systém CMS pre blogy a webstránky",
      des_en: "Open source CMS publishing system for blogs and websites",
      color: "#DDA10C",
      bg: "#FEFAF0",
    },

    {
      id: "5",
      icon_light: react,
      icon_dark: react,
      title: "React",
      des_sk: "JavaScript knižnica na tvorbu používateľských rozhraní",
      des_en: "A JavaScript library for building user interfaces",
      color: "#FF75D8",
      bg: "#FFF0F8",
    },
    {
      id: "6",
      icon_light: awsWhite,
      icon_dark: awsBlack,
      title: "Amazon Web Services",
      des_sk: "Cloud computing platform offered by Amazon.com",
      des_en: "Cloud computing platforma ponúkaná spoločnosťou Amazon.com",
      color: "#269FFF",
      bg: "#F3FAFF",
    },
    {
      id: "7",
      icon_light: linux,
      icon_dark: linux,
      title: "Linux Server Management",
      des_sk: "Nastavenie a údržba Linuxových serverov",
      des_en: "Configuration and maintenance of Linux servers",
      color: "#50c159",
      bg: "#a2e3aa",
    },
  ];

  const educationArray = [
    {
      id: 1,
      date_sk: "SEP 2011 - JÚN 2016",
      date_en: "SEP 2011 - JUNE 2016",
      title_sk: "Fakulta elektrotechniky a informatiky, Slovenská technická univerzita",
      title_en: "Faculty of Electrical Engineering and Information Technology, Slovak University of Technology",
      department_sk: "Aplikovaná informatika",
      department_en: "Applied Informatics",
      place_sk: "Bratislave, Slovenská republika",
      place_en: "Bratislava, Slovak Republic",
      bg: "#FFF1FB",
    },
    {
      id: 2,
      date_sk: "SEP 2007 - JÚN 2011",
      date_en: "SEP 2007 - JUNE 2011",
      title_sk: "Gymnázium Martina Kukučína",
      title_en: "Martin Kukučín High School",
      place_sk: "Revúca, Slovenská republika",
      place_en: "Revúca, Slovak Republic",
      bg: "#FFF4F4",
    },
  ];

  const experiencesArray = [
    {
      id: 1,
      date_sk: "APR 2024 - Doteraz",
      date_en: "APR 2024 - Currently",
      title_sk: "Web developer (Back-End)",
      title_en: "Web developer (Back-End)",
      company_sk: "eFabrica a.s.",
      company_en: "eFabrica a.s.",
      place_sk: "Bratislave, Slovenská republika",
      place_en: "Bratislava, Slovak Republic",
      bg: "#FFF4F4",
    },
    {
      id: 2,
      date_sk: "APR 2021 - APR 2024",
      date_en: "APR 2021 - APR 2024",
      title_sk: "Web developer (Full stack)",
      title_en: "Web developer (Full stack)",
      company_sk: "Webikon s.r.o.",
      company_en: "Webikon s.r.o.",
      place_sk: "Bratislave, Slovenská republika",
      place_en: "Bratislava, Slovak Republic",
      bg: "#FFF4F4",
    },
    /*{
      id: 3,
      date_sk: "JAN 2020 - APR 2021",
      date_en: "JAN 2020 - APR 2021",
      title_sk: "Web developer",
      title_en: "Web developer",
      company_sk: "Studio TEM, s.r.o.",
      company_en: "Studio TEM, s.r.o.",
      place_sk: "Bratislave, Slovenská republika",
      place_en: "Bratislava, Slovak Republic",
      bg: "#FFF4F4",
    },*/
    {
      id: 3,
      date_sk: "MAR 2018 - JAN 2020",
      date_en: "MAR 2018 - JAN 2020",
      title_sk: "Web developer (Full stack)",
      title_en: "Web developer (Full stack)",
      company_sk: "Freelancer",
      company_en: "Freelance",
      place_sk: "Bratislave, Slovenská republika",
      place_en: "Bratislava, Slovak Republic",
      bg: "#FFF4F4",
    },
  ];
  // awardsArray items for Resume page
  const awardsArray = [
    {
      id: 1,
      date: "2015-2017",
      title: "  Graphic Designer",
      place: "Web Graphy, Los Angeles, CA",
      bg: "#FCF4FF",
    },

    {
      id: 2,
      date: "2014 - 2015",
      title: "Jr. Web Developer",
      place: "Creative Gigs.",
      bg: "#FCF9F2",
    },

    {
      id: 3,
      date: "2015-2017",
      title: "Best Freelancer",
      place: "Fiver & Upwork Level 2 & Top Rated",
      bg: "#FCF4FF",
    },
  ];

  // Working Skills items for Resume page
  const lineArray = [
    {
      id: "01",
      color: "#F95054",
      name: "Laravel (PHP framework)",
      number: "90",
    },
    {
      id: "02",
      color: "#F95054",
      name: "Symfony (PHP framework)",
      number: "85",
    },
    {
      id: "03",
      color: "#F95054",
      name: "Sylius eCommerce Platform",
      number: "75",
    },
    {
      id: "04",
      color: "#F95054",
      name: "WordPress ",
      number: "93",
    },
    {
      id: "05",
      color: "#F95054",
      name: "React",
      number: "50",
    },
    {
      id: "07",
      color: "#F95054",
      name: "SQL, Redis, ElasticSearch",
      number: "85",
    },
    {
      id: "08",
      color: "#F95054",
      name: "Git, CI/CD pipelines, Docker",
      number: "85",
    },
    {
      id: "10",
      color: "#F95054",
      name: "Amazon Web Services (AWS) - EC2, RDS, Load balancing, S3, CDN, .. ",
      number: "75",
    },
  ];

  // Personal information for contact pages
  const contactArray = [
    {
      id: "01",
      icon: iconPhone,
      title: "Phone ",
      item1: "+452 666 386",
      item2: "+452 666 386",
      bg: "#FCF4FF",
    },
    {
      id: "02",
      icon: iconEmail,
      title: "Email ",
      item1: "support@gmail.com",
      item2: "example@gmail.com",
      bg: "#EEFBFF",
    },
    {
      id: "03",
      icon: iconMap,
      title: "Address ",
      item1: "Maount View, Oval",
      item2: "Road, New York, USA",
      bg: "#F2F4FF",
    },
  ];

  return {
    handleTheme,
    handleLanguage,
    check,
    local,
    handleData,
    data,
    dataCatsAll,
    singleData,
    handleModelData,
    isOpen,
    setIsOpen,
    blogsData,
    handleBlogsData,
    menuItem,
    NavLink,
    menuItemTwo,
    serviceArray,
    sliderImg,
    educationArray,
    experiencesArray,
    awardsArray,
    lineArray,
    contactArray,
  };
};

export default AllData;
